import { assertUnreachable } from '@interacta-shared/util';
import { AIConvoContext, AIConvoContextType } from './ai-convo-context.model';

export function toConversationalContext(context: AIConvoContext | null): {
    postId: number | null;
    communityId: number | null;
} {
    if (!context) return { postId: null, communityId: null };

    switch (context.type) {
        case AIConvoContextType.POST:
            return {
                postId: context.postId,
                communityId: context.communityId,
            };
        case AIConvoContextType.COMMUNITY:
            return { postId: null, communityId: context.communityId };
        case AIConvoContextType.HOME:
        case AIConvoContextType.DASHBOARD:
            return { postId: null, communityId: null };
        default:
            return assertUnreachable(context);
    }
}
